import { render, staticRenderFns } from "./ConfirmationLanguageChangeModal.vue?vue&type=template&id=d4784508&"
import script from "./ConfirmationLanguageChangeModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationLanguageChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports